export const ACCTRANS_LOADING = "ACCTRANS_LOADING";
export const GET_ACCTRANS_ONE = "GET_ACCTRANS_ONE";
export const ACCTRANS_RESET = "ACCTRANS_RESET";
export const GET_ACCTRANS = "GET_ACCTRANS";
export const GET_ACCTRANS_SUCCESS = "GET_ACCTRANS_SUCCESS";
export const GET_ACCTRANS_FAIL = "GET_ACCTRANS_FAIL";
export const DELETE_ACCTRANS = "DELETE_ACCTRANS"
export const DELETE_ACCTRANS_SUCCESS = "DELETE_ACCTRANS_SUCCESS"
export const DELETE_ACCTRANS_FAIL = "DELETE_ACCTRANS_FAIL"
export const UPDATE_ACCTRANS = "UPDATE_ACCTRANS"
export const UPDATE_ACCTRANS_SUCCESS = "UPDATE_ACCTRANS_SUCCESS"
export const UPDATE_ACCTRANS_FAIL = "UPDATE_ACCTRANS_FAIL"
export const ADD_NEW_ACCTRANS = "ADD_NEW_ACCTRANS"
export const ADD_ACCTRANS_SUCCESS = "ADD_ACCTRANS_SUCCESS"
export const ADD_ACCTRANS_FAIL = "ADD_ACCTRANS_FAIL"